/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GLDIds } from "./GLDIds";
import { GLDIdsFromJSON, GLDIdsFromJSONTyped, GLDIdsToJSON, GLDIdsToJSONTyped } from "./GLDIds";

/**
 *
 * @export
 * @interface ApiGldIdsList200Response
 */
export interface ApiGldIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGldIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGldIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGldIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GLDIds>}
   * @memberof ApiGldIdsList200Response
   */
  results: Array<GLDIds>;
}

/**
 * Check if a given object implements the ApiGldIdsList200Response interface.
 */
export function instanceOfApiGldIdsList200Response(
  value: object
): value is ApiGldIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGldIdsList200ResponseFromJSON(json: any): ApiGldIdsList200Response {
  return ApiGldIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGldIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGldIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GLDIdsFromJSON),
  };
}

export function ApiGldIdsList200ResponseToJSON(json: any): ApiGldIdsList200Response {
  return ApiGldIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGldIdsList200ResponseToJSONTyped(
  value?: ApiGldIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GLDIdsToJSON),
  };
}
